import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DaterangepickerModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
  SharedModule,
  AutocompleteModule,
  ComboModule,
  InputModule,
} from 'beyond-util';
import { IzvestajRealizacijeComponent } from './izvestaj-realizacije.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    SharedModule,
    DaterangepickerModule,
    AutocompleteModule,
    ComboModule,
    InputModule,
    NgxSpinnerModule,
  ],
  declarations: [IzvestajRealizacijeComponent],
  exports: [IzvestajRealizacijeComponent],
  entryComponents: [IzvestajRealizacijeComponent],
})
export class IzvestajRealizacijeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-realizacije/izvestaj-realizacije.module.ts